import { render } from "./Fornitore.vue?vue&type=template&id=40e25af2&scoped=true"
import script from "./Fornitore.vue?vue&type=script&lang=js"
export * from "./Fornitore.vue?vue&type=script&lang=js"

import "./Fornitore.vue?vue&type=style&index=0&id=40e25af2&lang=css"
import "./Fornitore.vue?vue&type=style&index=1&id=40e25af2&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e25af2"]])

export default __exports__